var CartDataTestIdEnum = /* @__PURE__ */ ((CartDataTestIdEnum2) => {
  CartDataTestIdEnum2["CART_HEADER_BUTTON"] = "cart--header-button";
  CartDataTestIdEnum2["CART_HEADER_BADGE"] = "cart--header-badge";
  CartDataTestIdEnum2["CART_DRAWER"] = "cart--drawer";
  CartDataTestIdEnum2["CART_DRAWER_TITLE"] = "cart--drawer-title";
  CartDataTestIdEnum2["CART_DRAWER_COUNT_BADGE"] = "cart--drawer-count-badge";
  CartDataTestIdEnum2["CART_DRAWER_CLOSE_BUTTON"] = "cart--drawer-close-button";
  CartDataTestIdEnum2["CART_ADD_PROCEDURE_BUTTON"] = "cart--add-procedure-button";
  CartDataTestIdEnum2["CART_COUPON_SECTION"] = "cart--coupon-section";
  CartDataTestIdEnum2["CART_COUPON_TOGGLE_BUTTON"] = "cart--coupon-toggle-button";
  CartDataTestIdEnum2["CART_COUPON_INPUT"] = "cart--coupon-input";
  CartDataTestIdEnum2["CART_COUPON_APPLY_BUTTON"] = "cart--coupon-apply-button";
  CartDataTestIdEnum2["CART_COUPON_REMOVE_BUTTON"] = "cart--coupon-remove-button";
  CartDataTestIdEnum2["CART_COUPON_MESSAGE"] = "cart--coupon-message";
  CartDataTestIdEnum2["CART_COUPON_NOTICE"] = "cart--coupon-notice";
  CartDataTestIdEnum2["CART_COUPON_NOTICE_DISMISS_BUTTON"] = "cart--coupon-notice-dismiss-button";
  CartDataTestIdEnum2["CART_ITEMS_LIST"] = "cart--items-list";
  CartDataTestIdEnum2["CART_ITEM"] = "cart--item";
  CartDataTestIdEnum2["CART_ITEM_PROFESSIONAL"] = "cart--item-professional";
  CartDataTestIdEnum2["CART_ITEM_PROCEDURE"] = "cart--item-procedure";
  CartDataTestIdEnum2["CART_ITEM_PRICE"] = "cart--item-price";
  CartDataTestIdEnum2["CART_ITEM_ORIGINAL_PRICE"] = "cart--item-original-price";
  CartDataTestIdEnum2["CART_ITEM_PROMOTION_PILL"] = "cart--item-promotion-pill";
  CartDataTestIdEnum2["CART_ITEM_COUPON_PILL"] = "cart--item-coupon-pill";
  CartDataTestIdEnum2["CART_ITEM_WARNING"] = "cart--item-warning";
  CartDataTestIdEnum2["CART_ITEM_DUPLICATE_WARNING"] = "cart--item-duplicate-warning";
  CartDataTestIdEnum2["CART_ITEM_FIELD_SCHEDULE"] = "cart--item-field-schedule";
  CartDataTestIdEnum2["CART_ITEM_FIELD_STANDALONE"] = "cart--item-field-standalone";
  CartDataTestIdEnum2["CART_ITEM_FIELD_FLEX"] = "cart--item-field-flex";
  CartDataTestIdEnum2["CART_ITEM_FIELD_PATIENT"] = "cart--item-field-patient";
  CartDataTestIdEnum2["CART_ITEM_FIELD_LOCATION"] = "cart--item-field-location";
  CartDataTestIdEnum2["CART_ITEM_EDIT_SCHEDULE_BUTTON"] = "cart--item-edit-schedule-button";
  CartDataTestIdEnum2["CART_ITEM_EDIT_PATIENT_BUTTON"] = "cart--item-edit-patient-button";
  CartDataTestIdEnum2["CART_ITEM_REMOVE_BUTTON"] = "cart--item-remove-button";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP"] = "cart--laboratory-group";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_HEADER"] = "cart--laboratory-group-header";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_COUPON_PILL"] = "cart--laboratory-group-coupon-pill";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_EXAM"] = "cart--laboratory-group-exam";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_EXAM_NAME"] = "cart--laboratory-group-exam-name";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_EXAM_PRICE"] = "cart--laboratory-group-exam-price";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_EXAM_REMOVE_BUTTON"] = "cart--laboratory-group-exam-remove-button";
  CartDataTestIdEnum2["CART_LABORATORY_GROUP_REMOVE_ALL_BUTTON"] = "cart--laboratory-group-remove-all-button";
  CartDataTestIdEnum2["CART_PROFESSIONAL_GROUP"] = "cart--professional-group";
  CartDataTestIdEnum2["CART_PROFESSIONAL_GROUP_HEADER"] = "cart--professional-group-header";
  CartDataTestIdEnum2["CART_PROFESSIONAL_GROUP_ITEM"] = "cart--professional-group-item";
  CartDataTestIdEnum2["CART_FOOTER"] = "cart--footer";
  CartDataTestIdEnum2["CART_FOOTER_TOTAL"] = "cart--footer-total";
  CartDataTestIdEnum2["CART_FOOTER_DISCOUNT"] = "cart--footer-discount";
  CartDataTestIdEnum2["CART_FOOTER_PROCEED_BUTTON"] = "cart--footer-proceed-button";
  CartDataTestIdEnum2["CART_EMPTY_STATE"] = "cart--empty-state";
  CartDataTestIdEnum2["CART_EMPTY_STATE_TITLE"] = "cart--empty-state-title";
  CartDataTestIdEnum2["CART_EMPTY_STATE_DESCRIPTION"] = "cart--empty-state-description";
  CartDataTestIdEnum2["CART_EMPTY_STATE_SEARCH_BUTTON"] = "cart--empty-state-search-button";
  CartDataTestIdEnum2["CART_LOADING"] = "cart--loading";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_MODAL"] = "cart--clear-confirmation-modal";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_TITLE"] = "cart--clear-confirmation-title";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_DESCRIPTION"] = "cart--clear-confirmation-description";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_CONFIRM_BUTTON"] = "cart--clear-confirmation-confirm-button";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_CANCEL_BUTTON"] = "cart--clear-confirmation-cancel-button";
  CartDataTestIdEnum2["CART_CLEAR_CONFIRMATION_CLOSE_BUTTON"] = "cart--clear-confirmation-close-button";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL"] = "cart--different-city-modal";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL_CLOSE_BUTTON"] = "cart--different-city-modal-close-button";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL_TITLE"] = "cart--different-city-modal-title";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL_DESCRIPTION"] = "cart--different-city-modal-description";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL_CONFIRM_BUTTON"] = "cart--different-city-modal-confirm-button";
  CartDataTestIdEnum2["CART_DIFFERENT_CITY_MODAL_CANCEL_BUTTON"] = "cart--different-city-modal-cancel-button";
  CartDataTestIdEnum2["CART_GUIDANCE"] = "cart--guidance";
  CartDataTestIdEnum2["CART_GUIDANCE_TITLE"] = "cart--guidance-title";
  CartDataTestIdEnum2["CART_GUIDANCE_CLOSE_BUTTON"] = "cart--guidance-close-button";
  CartDataTestIdEnum2["CART_GUIDANCE_INTRO"] = "cart--guidance-intro";
  CartDataTestIdEnum2["CART_GUIDANCE_IMPORTANT_INFO"] = "cart--guidance-important-info";
  CartDataTestIdEnum2["CART_GUIDANCE_BLOCK"] = "cart--guidance-block";
  CartDataTestIdEnum2["CART_GUIDANCE_BLOCK_TITLE"] = "cart--guidance-block-title";
  CartDataTestIdEnum2["CART_GUIDANCE_BLOCK_PILL"] = "cart--guidance-block-pill";
  CartDataTestIdEnum2["CART_GUIDANCE_BLOCK_INSTRUCTIONS"] = "cart--guidance-block-instructions";
  CartDataTestIdEnum2["CART_GUIDANCE_ACCEPT_CHECKBOX"] = "cart--guidance-accept-checkbox";
  CartDataTestIdEnum2["CART_GUIDANCE_BACK_BUTTON"] = "cart--guidance-back-button";
  CartDataTestIdEnum2["CART_GUIDANCE_CONTINUE_BUTTON"] = "cart--guidance-continue-button";
  return CartDataTestIdEnum2;
})(CartDataTestIdEnum || {});
export {
  CartDataTestIdEnum
};
